// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-top: 80px;
  min-height: 100vh;
  background-color: #FFFFFF;
}

.planTitle {
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.planSubtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
  text-align: center;
}

.planCards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
}

.planCard {
  flex: 1 1;
  min-width: 300px;
  max-width: 390px;
  height: 480px;
  border-radius: 10px;
  padding: 30px;
  background-color: rgba(255, 111, 15, 0.05);
  display: flex;
  flex-direction: column;
  border: 1px solid black;
}

.planName {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.sizeDescription {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
}

/* 캐러셀 스타일 */
.planCarousel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.carouselButton {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  transition: background-color 0.3s;
  color: #333;
}

.carouselButton:hover {
  background-color: #e0e0e0;
}

.planDuration {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
  position: relative;
}

.planDuration h3 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
}

.mostPopular {
  position: absolute;
  top: 10px;
  right: 10px;
  color: red;
  font-weight: bold;
  font-size: 14px;
}

.planPrice {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}

.pricePrefix {
  font-size: 16px;
  font-weight: bold;
  color: #666;
  margin-right: 5px;
}

.priceAmount {
  font-size: 36px;
  font-weight: bold;
  color: #333;
}

.priceSuffix {
  font-size: 16px;
  font-weight: bold;
  color: #666;
  margin-left: 5px;
}

.planDetails {
  margin-bottom: 20px;
  width: 100%;
}

.totalPrice, .discountPrice {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.detailLabel {
  color: #666;
  font-size: 14px;
}

.detailValue {
  font-weight: bold;
  font-size: 14px;
}

.highlight {
  color: #3A46B1;
}

.subscribeButton {
  padding: 15px;
  width: 310px;
  height: 80px;
  border: none;
  border-radius: 5px;
  background: rgba(255, 94, 7, 0.15);
  color: black;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  font-weight: bold;
  transition: background 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.subscribeButton:hover {
  background: rgba(255, 94, 7, 0.25);
}

.buttonPrefix {
  font-size: 12px;
  margin-bottom: 5px;
  font-weight: normal;
}

.buttonText {
  font-weight: bold;
}

.smallText {
  font-size: 12px;
  color: #333;
  margin-bottom: 5px;
}

/* 앱바 스타일은 Login.css와 공유 */
.appBar {
  display: flex;
  align-items: center;
  height: 60px;
  width: 100%;
  padding: 0 20px;
  background-color: #FFFBF7;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.appBarLogoImage {
  height: 30px;
}

/* 결제 방법 선택 영역 */
.paymentMethodContainer {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.paymentMethodContainer h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
}

.paymentOptions {
  display: flex;
  gap: 30px;
}

.paymentOption {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.paymentOption input {
  margin-right: 8px;
}

/* 에러 메시지 스타일 */
.errorMessage {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 20px;
  padding: 12px;
  background-color: #ffebee;
  color: #c62828;
  border-radius: 4px;
  text-align: center;
}

.discountPrice .detailLabel {
  color: #6C80E9;
} `, "",{"version":3,"sources":["webpack://./src/styles/PlanUpgrade.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".planContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  padding-top: 80px;\n  min-height: 100vh;\n  background-color: #FFFFFF;\n}\n\n.planTitle {\n  font-size: 50px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.planSubtitle {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.planCards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.planCard {\n  flex: 1;\n  min-width: 300px;\n  max-width: 390px;\n  height: 480px;\n  border-radius: 10px;\n  padding: 30px;\n  background-color: rgba(255, 111, 15, 0.05);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid black;\n}\n\n.planName {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.sizeDescription {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 15px;\n}\n\n/* 캐러셀 스타일 */\n.planCarousel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.carouselButton {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #f0f0f0;\n  border: 1px solid #ddd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px;\n  transition: background-color 0.3s;\n  color: #333;\n}\n\n.carouselButton:hover {\n  background-color: #e0e0e0;\n}\n\n.planDuration {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 10px;\n  position: relative;\n}\n\n.planDuration h3 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.mostPopular {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: red;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.planPrice {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 20px;\n}\n\n.pricePrefix {\n  font-size: 16px;\n  font-weight: bold;\n  color: #666;\n  margin-right: 5px;\n}\n\n.priceAmount {\n  font-size: 36px;\n  font-weight: bold;\n  color: #333;\n}\n\n.priceSuffix {\n  font-size: 16px;\n  font-weight: bold;\n  color: #666;\n  margin-left: 5px;\n}\n\n.planDetails {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.totalPrice, .discountPrice {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.detailLabel {\n  color: #666;\n  font-size: 14px;\n}\n\n.detailValue {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.highlight {\n  color: #3A46B1;\n}\n\n.subscribeButton {\n  padding: 15px;\n  width: 310px;\n  height: 80px;\n  border: none;\n  border-radius: 5px;\n  background: rgba(255, 94, 7, 0.15);\n  color: black;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 5px;\n  font-weight: bold;\n  transition: background 0.3s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.subscribeButton:hover {\n  background: rgba(255, 94, 7, 0.25);\n}\n\n.buttonPrefix {\n  font-size: 12px;\n  margin-bottom: 5px;\n  font-weight: normal;\n}\n\n.buttonText {\n  font-weight: bold;\n}\n\n.smallText {\n  font-size: 12px;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n/* 앱바 스타일은 Login.css와 공유 */\n.appBar {\n  display: flex;\n  align-items: center;\n  height: 60px;\n  width: 100%;\n  padding: 0 20px;\n  background-color: #FFFBF7;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.appBarLogoImage {\n  height: 30px;\n}\n\n/* 결제 방법 선택 영역 */\n.paymentMethodContainer {\n  width: 100%;\n  max-width: 1200px;\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n}\n\n.paymentMethodContainer h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.paymentOptions {\n  display: flex;\n  gap: 30px;\n}\n\n.paymentOption {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.paymentOption input {\n  margin-right: 8px;\n}\n\n/* 에러 메시지 스타일 */\n.errorMessage {\n  width: 100%;\n  max-width: 1200px;\n  margin-bottom: 20px;\n  padding: 12px;\n  background-color: #ffebee;\n  color: #c62828;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.discountPrice .detailLabel {\n  color: #6C80E9;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
